/* eslint-disable */
import { createApp } from 'vue';
import { createPinia } from 'pinia'
import App from './App.vue';
import router from './router'; // Import router
import './main.css'; // Import Tailwind CSS
import 'sweetalert2/dist/sweetalert2.min.css';
// eslint-disable-next-line import/extensions

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const app = createApp(App);
const pinia = createPinia();

app.use(pinia)
app.use(router);
app.component('font-awesome-icon', FontAwesomeIcon)

// Google Analytics page view tracking - Production Only
if (process.env.VUE_APP_GA_ID) {
  router.afterEach((to) => {
    if (typeof gtag !== 'undefined') {
      gtag('config', process.env.VUE_APP_GA_ID, {
        page_path: to.fullPath,
        page_title: to.meta.title || document.title
      });
    }
  });
}

app.mount('#app');
